<h1>Marketing Campaings</h1>
<nav mat-tab-nav-bar [tabPanel]="tabPanel">
    <a mat-tab-link *ngFor="let tab of tabs" (click)="gotoTab(tab)"
       [active]="tab.link == activeTab.link">{{tab.title}}</a>
</nav>
<app-marketing-campaigns-list *ngIf="activeTab.id === 'list'"></app-marketing-campaigns-list>
<app-marketing-campaigns-groups *ngIf="activeTab.id === 'groups'"></app-marketing-campaigns-groups>
<app-marketing-campaigns-history *ngIf="activeTab.id === 'history'"></app-marketing-campaigns-history>
<mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
